import { render, staticRenderFns } from "./detail-order-collaborator.vue?vue&type=template&id=13ed83ae&scoped=true&"
import script from "./detail-order-collaborator.vue?vue&type=script&lang=js&"
export * from "./detail-order-collaborator.vue?vue&type=script&lang=js&"
import style0 from "./detail-order-collaborator.vue?vue&type=style&index=0&id=13ed83ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed83ae",
  null
  
)

export default component.exports